import { render, staticRenderFns } from "./radish-experience-popper.vue?vue&type=template&id=35f42ed3&"
import script from "./radish-experience-popper.vue?vue&type=script&lang=js&"
export * from "./radish-experience-popper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports